import { Helmet } from 'react-helmet-async';
import BookingForm from '../components/booking/BookingForm';

const BookingPage = () => {
    return (
        <div>
            <Helmet>
                <title>Room 49 – Book a desk in our shared office</title>
                <meta name="description" content="Book your workspace at Room 49. Choose a day pass or a monthly option—self-service, easy access, no distractions." />
                <link rel="canonical" href='https://thetypingrooms.co.uk/booking' />
            </Helmet>
            <div className="page">
                <div className="page-header">
                    <h1>Book a desk</h1>
                </div>
                <div className='page-content'>
                    <p>
                        Room 49 offers daily or monthly desks. Both include fast Wi-Fi and a calm, comfortable setup. Monthly desks come with wired internet and space for extra screens. Once you pick a date, the floorplan will appear—then just click the desk number buttons underneath to book.
                    </p>
                    <BookingForm />
                </div>
            </div>
        </div>
    );
};

export default BookingPage;
